import LogoutContent from "@/components/Authentication/LogoutContent"

export default function Logout() {
  return (
    <>
      <LogoutContent />
    </>
  )
}
